<template>
  <div id="page"></div>
</template>
<script lang="ts" setup>
import { onMounted, nextTick } from "vue";
import { useSdkStore } from "@/stores/sdk";
import { initSdk } from "@/sdk/init";

import { useRouter, useRoute } from "vue-router";
const router = useRouter();
const route = useRoute()
const sdkStore = useSdkStore();
import { initDesign } from '@/common/initDesign'
import { useUserStore } from '@/stores/user'
const userStore = useUserStore()
const islogin = userStore.isLoggedIn
//@ts-ignore
onMounted(async () => {

  await nextTick();
  const desginsdk = await initSdk("#page", islogin);
  sdkStore.setSdk(desginsdk);
  initDesign()
});
</script>
<style lang="scss">
.custom-thin {
  position: fixed;
  top: 10px;
  left: 10px;
}
</style>
